import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungIserlohn() {
  return (
    <CityPageTemplate
      city="Iserlohn"
      slug="iserlohn"
      intro="Iserlohn als größte Stadt des Märkischen Kreises – unabhängige Finanzberatung für das Süderland."
      description="Unabhängige & digitale Finanzberatung für Iserlohn: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
